<template>
    <v-container fluid>
        <Overlay />
        <v-row
            align="center"
            justify="center"
        >
            <v-col
                cols="12"
                md="11"
                class="d-flex flex-row justify-space-between align-center"
            >
                <h1>Edit Population</h1>
                <v-btn to="/population/create">
                    <v-icon
                        left
                        small
                    >
                        fas fa-plus-circle
                    </v-icon>
                    Add Population
                </v-btn>
            </v-col>
        </v-row>

        <v-row
            align="start"
            justify="center"
            class="d-flex flex-row justify-center"
        >
            <v-col
                cols="12"
                md="7"
                justify="center"
            >
                <PopulationEditForm
                    v-if="hydrated"
                    :key="routerParamPopulationId"
                />
            </v-col>
            <v-col
                cols="12"
                md="4"
                justify="center"
            >
                <PopulationStructure
                    v-if="hydrated"
                    :key="routerParamPopulationId"
                />
            </v-col>
        </v-row>

        <v-dialog
            v-model="deleteModal"
            width="500"
        >
            <v-card>
                <v-card-title> Delete Population</v-card-title>

                <v-card-text>
                    <p>
                        You are about to remove this step and all of its fields. This cannot be undone. Any existing
                        user data for these fields will be orphaned.
                    </p>
                    <p>The following data will be deleted:</p>
                </v-card-text>

                <v-divider />

                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        text
                        @click="toggleDeleteModal(false)"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        color="primary"
                        @click="destroy()"
                    >
                        Delete Population
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import PopulationEditForm from './PopulationEditForm';
import Overlay from '../../../../components/Overlay';
import PopulationStructure from './PopulationStructure';
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
    components: { PopulationStructure, Overlay, PopulationEditForm },

    props: [
        'routerParamPopulationId',
    ],

    computed: {
        ...mapState('populationEditor', ['deleteModal', 'hydrated'])
    },

    watch: {
        routerParamPopulationId(value) {
            this.getData(value);
        },
    },

    mounted() {
        this.getData(this.routerParamPopulationId);
    },

    methods: {
        ...mapMutations({
            toggleDeleteModal: 'populationEditor/toggleDeleteModal'
        }),

        ...mapActions({
            showNotification: 'notification/show',
            getData: 'populationEditor/getData',
            saveData: 'populationEditor/saveData',
            destroyData: 'populationEditor/destroyData'
        }),

        destroy() {
            this.toggleDeleteModal(false);
            this.destroyData();
        }
    }
};
</script>
